/**
 * Batterikapacitet (kWh) från Car.info via spec-id.
 * Netto (5482) före brutto (743). 12V-batteriet (2608, Ah) har ett annat id.
 */

import { flattenCarInfoSpecAttrs, type CarInfoExtendedAttr } from './carInfoGeneral';
import { SPEC_ID_BATTERY_KWH_GROSS, SPEC_ID_BATTERY_KWH_NET } from './carInfoSpecIds';

const BATTERY_KWH_IDS = [SPEC_ID_BATTERY_KWH_NET, SPEC_ID_BATTERY_KWH_GROSS];

interface CarInfoLike {
  specifications?: unknown[] | null;
  basicAttributes?: unknown;
  extendedAttributes?: unknown;
}

function parseKwh(values: unknown): number | null {
  const raw = Array.isArray(values) ? values.join(' ') : String(values ?? '');
  const match = raw.replace(',', '.').match(/-?\d+(\.\d+)?/);
  if (!match) return null;
  const n = Number(match[0]);
  if (!Number.isFinite(n) || n <= 0 || n > 500) return null;
  return n;
}

function flattenLoose(nodes: unknown): CarInfoExtendedAttr[] {
  if (!nodes) return [];
  if (Array.isArray(nodes)) {
    return flattenCarInfoSpecAttrs([{ attributes: Object.fromEntries(nodes.map((node, index) => [String(index), node])) }]);
  }
  if (typeof nodes === 'object') {
    return flattenCarInfoSpecAttrs([{ attributes: nodes as Record<string, CarInfoExtendedAttr> }]);
  }
  return [];
}

export function extractBatteryCapacityKwh(carInfo: CarInfoLike | null | undefined): number | null {
  if (!carInfo) return null;
  const attrs = [
    ...flattenCarInfoSpecAttrs(carInfo.specifications ?? undefined),
    ...flattenLoose(carInfo.basicAttributes),
    ...flattenLoose(carInfo.extendedAttributes),
  ];
  for (const specId of BATTERY_KWH_IDS) {
    const attr = attrs.find((item) => String(item.id ?? '') === specId);
    if (!attr) continue;
    if (attr.unit && !/kwh/i.test(attr.unit)) continue;
    const value = parseKwh(attr.values);
    if (value != null) return value;
  }
  return null;
}
